const constant = {
  // baseUrl: "http://localhost:5000/api/v1",
  baseUrl: "https://api.dranoop.in/api/v1",
};
export { constant };
